const smartDamageIndex = () => import('@/pages/smartDamage/index')
const smartDamageFeetools = () => import('@/pages/smartDamage/feetools')

export default [
  {
    path: '/smartDamageIndex',
    name: '/smartDamageIndex',
    component: smartDamageIndex,
    meta: {
      storeKey: 'trs.smartDamageIndex'
    }
  },
  {
    path: '/smartDamageFeetools',
    name: '/smartDamageFeetools',
    component: smartDamageFeetools,
    meta: {
      storeKey: '*'
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/smartDamage/index.js